import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

import "./Career.scss";

class Career extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let careers = this.state.data.career;

        return (
            <section id="career">
                <Container fluid>
                    <Row>
                        <Fade right delay={200} duration={800} distance="20%" fraction={1}>
                            <h2 className="section-title">Career</h2>
                        </Fade>
                        <Fade left delay={400} duration={800} distance="500px" fraction={1}>
                            <div className="section-title-underline"></div>
                        </Fade>
                    </Row>
                    {careers.map((career, index) => {
                        let timeline = career.timeline === "Present" ? "career-element-section-present" : "";

                        return <Row key={index} className={`career-element-section ${timeline}`}>
                            <Col className="career-element-date-section">
                                <Fade left delay={400} duration={1000} distance="200%" fraction={1}>
                                    <h6 className="career-element-date">{career.timeline}</h6>
                                </Fade>
                                <Fade left delay={200} duration={800} distance="200%" fraction={0.01}>
                                    <div className="career-element-date-line">
                                        <div className="career-element-date-circle" />
                                    </div>
                                </Fade>
                            </Col>
                            <Col>
                                <Row>
                                    <Col className="career-element-text-section">
                                        <Zoom delay={100} duration={800} fraction={0.2}>
                                            <div>
                                                <h4 className="career-element-title">{career.title}</h4>
                                                <h6 className="career-element-subtitle">{career.subtitle}</h6>
                                                <p className="career-element-description">{career.description}</p>
                                                <ul className="career-element-list">
                                                    {career.bulletpoints.map((bulletpoint, index) => {
                                                        return <li key={index} className="career-element-list-item">{bulletpoint}</li>
                                                    })}
                                                </ul>
                                            </div>
                                        </Zoom>
                                    </Col>
                                    <Col lg={4} className="career-element-image-section">
                                        <Fade right delay={200} duration={1000} distance="200%" fraction={0.2}>
                                            <Image className="career-element-image" src={`/images/${career.image}`} rounded />
                                        </Fade>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    })}
                </Container>
            </section >
        );
    }
}

export default Career;
